// (bnikom) text when sale is 2hrs from start time
const catalog2HrWarning = 'Catalog is within 2 hours of sale start time';

const catalogNoEdit = 'You can not edit, delete or add additional lots at this time.';

const errorLoadingCatalogText = 'Unable to load your catalog information. Please try again later or contact Customer Care any time at:';

const fileDeleteErrorText = 'Unable to delete your file(s).  Please try again later or contact Customer Care any time at:';

const offlineErrorText = 'Please verify you are connected to the internet and try again.';

const errorLoadingRealized = 'Unable to load your realized prices. Please try again later or contact Customer Care any time at:';

export {
  catalog2HrWarning,
  catalogNoEdit,
  errorLoadingCatalogText,
  fileDeleteErrorText,
  offlineErrorText,
  errorLoadingRealized
};
